var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabRent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 438,
    height: 584,
    viewBox: "0 0 438 584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "padlock",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5191",
    "data-name": "Path 5191",
    d: "M386.25,374H57.75A54.817,54.817,0,0,1,3,319.25V63.75A54.817,54.817,0,0,1,57.75,9h328.5A54.817,54.817,0,0,1,441,63.75v255.5A54.817,54.817,0,0,1,386.25,374ZM57.75,45.5A18.272,18.272,0,0,0,39.5,63.75v255.5A18.272,18.272,0,0,0,57.75,337.5h328.5a18.272,18.272,0,0,0,18.25-18.25V63.75A18.272,18.272,0,0,0,386.25,45.5Z",
    transform: "translate(-3 210)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5192",
    "data-name": "Path 5192",
    d: "M279.75,255.5a18.257,18.257,0,0,1-18.25-18.25V146a109.5,109.5,0,0,0-219,0v91.25a18.25,18.25,0,0,1-36.5,0V146C6,65.481,71.481,0,152,0S298,65.481,298,146v91.25A18.257,18.257,0,0,1,279.75,255.5Z",
    transform: "translate(67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5193",
    "data-name": "Path 5193",
    d: "M58.667,110.333a48.667,48.667,0,1,1,48.667-48.667A48.716,48.716,0,0,1,58.667,110.333Zm0-60.833A12.167,12.167,0,1,0,70.833,61.667,12.187,12.187,0,0,0,58.667,49.5Z",
    transform: "translate(160.333 303.333)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5194",
    "data-name": "Path 5194",
    d: "M29.5,119.167a18.257,18.257,0,0,1-18.25-18.25V34a18.25,18.25,0,1,1,36.5,0v66.917A18.257,18.257,0,0,1,29.5,119.167Z",
    transform: "translate(189.5 367.5)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabRent);
export default __webpack_public_path__ + "static/media/tab-rent.d99c4ed573ea32260d655ebd228f1bb5.svg";
export { ForwardRef as ReactComponent };